<template>
    <v-form ref="form" v-model="valid">
        <SoliText
            number
            @input="$emit('input', $event)"
            label="Occurrences"
            :value="recommended"
            hide-details="auto"
            icon="people"
            :min="1"
            :max="100"
            :rules="[(val) => !!val || 'This field is required']"
            :validateOnBlur="false"
    /></v-form>
</template>

<script>
export default {
    props: {
        recommended: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            valid: !!this.recommended,
        };
    },
    watch: {
        valid(value) {
            this.$emit("valid", !value);
        },
    },
    mounted() {
        this.$emit("input", this.recommended);
    },
};
</script>
